import React, { useEffect, useState, useCallback } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { Loader, ErrorBanner } from '../../components/common/Feedback';
import * as notificationsApi from '../../api/notifications';
import { formatDateTime } from '../../utils/format';

export default function Notifications() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    notificationsApi
      .listNotifications({})
      .then((res) => setRows(res.data))
      .catch((err) => setError(err.response?.data?.message || 'Failed to load notifications.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleMarkRead = async (row) => {
    await notificationsApi.markNotificationRead(row.id);
    load();
  };

  const handleMarkAllRead = async () => {
    await notificationsApi.markAllNotificationsRead();
    load();
  };

  return (
    <DashboardLayout title="Notifications">
      <div className="page-header">
        <div>
          <h1 className="heading">Notifications</h1>
          <p className="page-subtext">Updates relevant to your work.</p>
        </div>
        <button type="button" className="btn btn-secondary" onClick={handleMarkAllRead}>Mark All as Read</button>
      </div>

      <ErrorBanner message={error} />

      {loading ? (
        <Loader text="Loading notifications..." />
      ) : rows.length === 0 ? (
        <p className="text-muted">You're all caught up.</p>
      ) : (
        rows.map((n) => (
          <div key={n.id} className="card" style={{ backgroundColor: n.isRead ? undefined : 'var(--color-secondary)' }}>
            <div className="flex-between">
              <p style={{ margin: 0 }}>{n.message}</p>
              {!n.isRead && <button type="button" className="btn-link" onClick={() => handleMarkRead(n)}>Mark Read</button>}
            </div>
            <div className="text-muted" style={{ fontSize: '9.5pt', marginTop: 6 }}>{formatDateTime(n.createdAt)}</div>
          </div>
        ))
      )}
    </DashboardLayout>
  );
}
